import { render, staticRenderFns } from "./CardAvatar.vue?vue&type=template&id=1f2b6a9b&"
import script from "./CardAvatar.vue?vue&type=script&lang=js&"
export * from "./CardAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CardAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports